import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStackedBarChart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconStackedBarChart2"><Path d="M9.5 6C10.3284 6 11 6.67157 11 7.5V19H13V10.5C13 9.67157 13.6716 9 14.5 9C15.3284 9 16 9.67157 16 10.5V19H17V5.5C17 4.67157 17.6716 4 18.5 4C19.3284 4 20 4.67157 20 5.5V19H21.5C21.7761 19 22 19.2239 22 19.5C22 19.7761 21.7761 20 21.5 20H2.5C2.22386 20 2 19.7761 2 19.5C2 19.2239 2.22386 19 2.5 19H4V12.5C4 11.6716 4.67157 11 5.5 11C6.32843 11 7 11.6716 7 12.5V19H8V7.5C8 6.67157 8.67157 6 9.5 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStackedBarChart2;
